import React, {useState} from "react";
import './MT4Top.css';
import YouTube from "react-youtube";
import {MT4TopArrayProfiforexFunc} from "./MT4TopArrayForexstart";
import ChangeLink from "../../../Elements/ChangeLink/ChangeLink";
const opts = {
    playerVars: {
        autoplay: 1,
    }};
function MT4Top(props){

    function TextSource(info) {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*' + info.children}</>} catch (err) {return <>*{info.children}</>}}

    const [VideoFile, setVideoFile] = useState('');

    function SetVideoFile(name) {
        if (name) {setVideoFile(name);}}
        let LangForTop = props.lang;
        if (LangForTop === 'cn') {LangForTop = 'en'}
        if (LangForTop === 'ua') {LangForTop = 'ru'}
        const VideoArray = MT4TopArrayProfiforexFunc(props.videoType,LangForTop);
        let FirstVideo = VideoArray[0].video;

        const VideoArrayMap = VideoArray.map((element) =>
                    <div className="MT4TopElementIn" onClick={() => SetVideoFile(element.video)} role="button" tabIndex={0} >{element.text}</div>


        );
    return (
        <div className="MT4TopOut">
            <div className="MT4Top">
                <div className="MT4TopIn">
                    <ChangeLink activeClassName={'MT4TopLinkActive'} lang={props.lang} to='/education/mt4'><TextSource ArrIndex= 'MT4Top0000'>Учебник по MetaTrader</TextSource></ChangeLink>
                    <ChangeLink activeClassName={'MT4TopLinkActive'} lang={props.lang} to='/education/mt4professional'><TextSource ArrIndex= 'MT4Top0005'>Профессиональные системы</TextSource></ChangeLink>
                    <ChangeLink activeClassName={'MT4TopLinkActive'} lang={props.lang} to='/education/mt4indicators'><TextSource ArrIndex= 'MT4Top0010'>MT4 Индикаторы</TextSource></ChangeLink>
                    <ChangeLink activeClassName={'MT4TopLinkActive'} lang={props.lang} to='/education/mt4analysis'><TextSource ArrIndex= 'MT4Top0015'>Графический анализ</TextSource></ChangeLink>
                </div>
            </div>
            <div className="MT4MainTop">
                <div className="MT4MainTopIn">
                    {VideoArrayMap}
                </div>
            </div>
            <div className="MT4TopYoutube">
                <YouTube videoId={VideoFile || FirstVideo} opts={opts} />
            </div>

        </div>
    )}

export default MT4Top




